<section class="w-full bg-white p-3 sm:p-4 lg:p-6 shadow-sm">
  <h2 class="text-xl sm:text-2xl lg:text-3xl font-semibold px-1 mt-2 mb-4 sm:mb-6 text-gray-800">
    Liste des utilisateurs
  </h2>
  
  <!-- Header avec recherche et bouton d'ajout -->
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 lg:gap-6 mb-6">
    <!-- Barre de recherche -->
    <div class="relative flex-1 min-w-0">
      <input
        type="text"
        [(ngModel)]="itemToSearch.nom"
        placeholder="Rechercher par nom..."
        (keyup)="onSearch()"
        class="pl-10 pr-4 py-2 rounded border w-[280px]"
      />
      <span class="bi bi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base"></span>
    </div>
    
    <!-- Bouton d'ajout -->
    <button
      type="button"
      (click)="openModal()"
      class="flex items-center justify-center gap-2 px-4 py-2.5 sm:py-3 sm:px-6 bg-orange-400 rounded-lg text-white hover:bg-orange-500 transition-all font-medium text-sm sm:text-base whitespace-nowrap"
    >
      <i class="bi bi-person-plus text-sm sm:text-base"></i>
      <span class="hidden xs:inline">Ajouter</span>
      <span class="hidden sm:inline">utilisateur</span>
    </button>
  </div>

  <!-- Version mobile et tablette : Cards -->
  <div class="block lg:hidden space-y-3 sm:space-y-4">
    @for(item of itemsUser; track item.id; let i = $index) {
      <div class="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 shadow-sm hover:shadow-md transition-shadow">
        <!-- Header de la card -->
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0 pr-3">
            <h3 class="font-semibold text-gray-900 text-sm sm:text-base truncate">
              {{ item.nom + " " + item.prenoms || "-" }}
            </h3>
            <p class="text-xs sm:text-sm text-gray-500 mt-1">N° {{ i + 1 }}</p>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <!-- Statut -->
            <span
              [ngClass]="{
                'bg-green-100 text-green-600': !item.isLocked,
                'bg-red-100 text-red-600': item.isLocked
              }"
              class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap"
            >
              @if(!item.isLocked) {
                <svg class="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"/>
                </svg>
                <span class="hidden xs:inline">Actif</span>
              } @else {
                <svg class="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2a4 4 0 00-4 4v2H5a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2v-7a2 2 0 00-2-2h-1V6a4 4 0 00-4-4zm-2 6V6a2 2 0 114 0v2H8z"/>
                </svg>
                <span class="hidden xs:inline">Inactif</span>
              }
            </span>
            
            <!-- Menu d'actions -->
            <div class="dropdown relative">
              <button
                class="bg-orange-400 text-white p-1.5 sm:p-2 rounded-md hover:bg-orange-500 transition-colors"
                (click)="toggleDropdown(item.id)"
              >
                <i class="bi bi-three-dots-vertical text-xs sm:text-sm"></i>
              </button>
              
              <div
                class="dropdown-menu absolute right-0 mt-2 bg-white shadow-lg rounded-lg z-10 w-48 sm:w-52 border border-gray-200"
                [ngClass]="{ hidden: activeDropdown !== item.id }"
              >
                <ul class="py-1">
                  <li>
                    <button
                      class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      (click)="openModal(item)"
                    >
                      <i class="bi bi-pencil-fill text-yellow-500 mr-2 flex-shrink-0"></i>
                      <span>Modifier</span>
                    </button>
                  </li>
                  
                  @if(!item.isLocked && item.id !== currentUserId) {
                    <li>
                      <button
                        class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                        (click)="confirmStatut(item)"
                      >
                        <i class="bi bi-lock-fill text-yellow-500 mr-2 flex-shrink-0"></i>
                        <span>Verrouiller</span>
                      </button>
                    </li>
                  } @else if(item.isLocked && item.id !== currentUserId) {
                    <li>
                      <button
                        class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                        (click)="confirmStatut(item)"
                      >
                        <i class="bi bi-unlock-fill text-yellow-500 mr-2 flex-shrink-0"></i>
                        <span>Déverrouiller</span>
                      </button>
                    </li>
                  }
                  
                  <li>
                    <button
                      class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      (click)="renitialiserMdp(item)"
                    >
                      <i class="bi bi-key-fill text-yellow-500 mr-2 flex-shrink-0"></i>
                      <span>Réinitialiser compte</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Contenu de la card -->
        <div class="space-y-2 sm:space-y-3">
          <div class="flex flex-col xs:flex-row xs:justify-between gap-1 xs:gap-2">
            <span class="text-xs sm:text-sm text-gray-500 flex-shrink-0">Email:</span>
            <span class="text-xs sm:text-sm text-gray-900 font-medium break-all xs:text-right">
              {{ item.email }}
            </span>
          </div>
          <div class="flex flex-col xs:flex-row xs:justify-between gap-1 xs:gap-2">
            <span class="text-xs sm:text-sm text-gray-500 flex-shrink-0">Profil:</span>
            <span class="text-xs sm:text-sm text-gray-900 font-medium xs:text-right">
              {{ item.profil === 'user' ? 'Utilisateur' : (item.profil || '-') }}
            </span>
          </div>
        </div>
      </div>
    } @empty {
      <div class="text-center py-10 sm:py-12 text-gray-500">
        <div class="flex flex-col items-center justify-center">
          <i class="bi bi-inbox text-4xl sm:text-5xl mb-2 sm:mb-3"></i>
          <p class="text-sm sm:text-base">Aucune donnée disponible</p>
        </div>
      </div>
    }
  </div>

  <!-- Version desktop : Table -->
  <div class="hidden lg:block overflow-x-auto rounded-lg shadow-sm">
    <div class="mb-28">
      <table class="min-w-full bg-white">
        <thead>
          <tr class="text-gray-600 border-b bg-gray-50">
            <th class="p-3 xl:p-4 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span class="font-semibold text-sm xl:text-base">N°</span>
              </div>
            </th>
            <th class="p-3 xl:p-4 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span class="font-semibold text-sm xl:text-base">Nom et Prénoms</span>
              </div>
            </th>
            <th class="p-3 xl:p-4 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span class="font-semibold text-sm xl:text-base">Email</span>
              </div>
            </th>
            <th class="p-3 xl:p-4 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span class="font-semibold text-sm xl:text-base">Profil</span>
              </div>
            </th>
            <th class="p-3 xl:p-4 whitespace-nowrap text-center">
              <span class="font-semibold text-sm xl:text-base">Statut</span>
            </th>
            <th class="p-3 xl:p-4 whitespace-nowrap text-center">
              <span class="font-semibold text-sm xl:text-base">Action</span>
            </th>
          </tr>
        </thead>
        <tbody class="custom-table">
          @for(item of itemsUser; track item.id; let i = $index) {
            <tr class="border-b hover:bg-gray-50 transition-colors {{ i % 2 === 0 ? 'bg-white' : 'bg-gray-50' }}">
              <td class="p-3 xl:p-4 text-sm xl:text-base">{{ i + 1 }}</td>
              <td class="p-3 xl:p-4 text-sm xl:text-base font-medium">
                {{ item.nom + " " + item.prenoms || "-" }}
              </td>
              <td class="p-3 xl:p-4 text-sm xl:text-base">{{ item.email }}</td>
              <td class="p-3 xl:p-4 text-sm xl:text-base">
                <span class="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs xl:text-sm font-medium">
                  {{ item.profil === 'user' ? 'Utilisateur' : (item.profil || '-') }}
                </span>
              </td>
              <td class="p-3 xl:p-4 text-center whitespace-nowrap">
                <span
                  [ngClass]="{
                    'bg-green-100 text-green-600': !item.isLocked,
                    'bg-red-100 text-red-600': item.isLocked
                  }"
                  class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs xl:text-sm font-medium"
                >
                  @if(!item.isLocked) {
                    <svg class="w-3 h-3 xl:w-4 xl:h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"/>
                    </svg>
                    Actif
                  } @else {
                    <svg class="w-3 h-3 xl:w-4 xl:h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 2a4 4 0 00-4 4v2H5a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2v-7a2 2 0 00-2-2h-1V6a4 4 0 00-4-4zm-2 6V6a2 2 0 114 0v2H8z"/>
                    </svg>
                    Inactif
                  }
                </span>
              </td>
              <td class="text-center py-3 xl:py-4">
                <div class="dropdown inline-block relative">
                  <button
                    class="bg-orange-400 text-white p-2 xl:p-2.5 rounded-md flex items-center justify-center gap-1 text-sm hover:bg-orange-500 transition-colors"
                    (click)="toggleDropdown(item.id)"
                  >
                    <span class="hidden xl:inline">Action</span>
                    <i class="bi bi-chevron-down text-xs xl:text-sm"></i>
                  </button>
                  
                  <div
                    class="dropdown-menu absolute right-0 mt-2 bg-white shadow-lg rounded-md z-10 w-44 xl:w-48 border border-gray-200"
                    [ngClass]="{ hidden: activeDropdown !== item.id }"
                  >
                    <ul class="py-1">
                      <li>
                        <button
                          class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                          (click)="openModal(item)"
                        >
                          <i class="bi bi-pencil-fill text-yellow-500 mr-2"></i>
                          <span>Modifier</span>
                        </button>
                      </li>
                      
                      @if(!item.isLocked && item.id !== currentUserId) {
                        <li>
                          <button
                            class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                            (click)="confirmStatut(item)"
                          >
                            <i class="bi bi-lock-fill text-yellow-500 mr-2"></i>
                            <span>Verrouiller</span>
                          </button>
                        </li>
                      } @else if(item.isLocked && item.id !== currentUserId) {
                        <li>
                          <button
                            class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                            (click)="confirmStatut(item)"
                          >
                            <i class="bi bi-unlock-fill text-yellow-500 mr-2"></i>
                            <span>Déverrouiller</span>
                          </button>
                        </li>
                      }
                      
                      <li>
                        <button
                          class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                          (click)="renitialiserMdp(item)"
                        >
                          <i class="bi bi-key-fill text-yellow-500 mr-2"></i>
                          <span>Réinitialiser compte</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="6" class="text-center py-10 xl:py-12 text-gray-500">
                <div class="flex flex-col items-center justify-center">
                  <i class="bi bi-inbox text-4xl xl:text-5xl mb-2 xl:mb-3"></i>
                  <p class="text-sm xl:text-base">Aucune donnée disponible</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
  <div class="mt-6 flex flex-col sm:flex-row justify-between items-center w-full p-3 sm:p-4 rounded-lg shadow-sm bg-white gap-3">
    <div class="w-full sm:w-auto order-2 sm:order-1">
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20, 40, 80]"
        [pageIndex]="currentPage"
        [pageSize]="itemsPerPage"
        [length]="totalItems"
        (page)="pageChanged($event)"
        aria-label="Sélectionner une page"
        class="text-sm"
      >
      </mat-paginator>
    </div>
    <div class="text-sm sm:text-base text-gray-600 font-medium order-1 sm:order-2">
      Total : {{ totalItems || 0 }} utilisateur{{ (totalItems || 0) > 1 ? 's' : '' }}
    </div>
  </div>
</section>

<!-- Modal -->
@if (showModal) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2 sm:p-4">
    <div class="bg-white w-full max-w-xs sm:max-w-2xl lg:max-w-4xl xl:max-w-5xl max-h-[95vh] sm:max-h-[90vh] rounded-lg shadow-xl overflow-hidden flex flex-col">
      <!-- Modal Header -->
      <div class="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center flex-shrink-0">
        <h1 class="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800">
          {{ itemToSave.id ? "Modifier" : "Ajouter" }} un utilisateur
        </h1>
        <button
          (click)="closeModal()"
          class="p-2 rounded-full hover:bg-gray-200 transition-colors text-gray-600 flex-shrink-0"
        >
          <i class="bi bi-x-lg text-sm sm:text-base"></i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="flex-1 overflow-y-auto p-4 sm:p-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
          <!-- Left Column -->
          <div class="space-y-4 sm:space-y-5">
            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Nom <span class="text-red-500">*</span>
              </label>
              <input
                [(ngModel)]="itemToSave.nom"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
                placeholder="Entrez le nom"
              />
            </div>

            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Prénoms <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                [(ngModel)]="itemToSave.prenoms"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
                placeholder="Entrez les prénoms"
              />
            </div>

            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Email <span class="text-red-500">*</span>
              </label>
              <input
                [(ngModel)]="itemToSave.email"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
                placeholder="exemple@email.com"
                type="email"
              />
            </div>
          </div>

          <!-- Right Column -->
          <div class="space-y-4 sm:space-y-5">
            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Contact <span class="text-red-500">*</span>
              </label>
              <input
                [(ngModel)]="itemToSave.telephone"
                (keydown)="validateNumberInput($event)"
                (paste)="validateNumberPaste($event)"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
                placeholder="Numéro de téléphone"
                type="tel"
              />
            </div>

            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Profil <span class="text-red-500">*</span>
              </label>
              <select
                [(ngModel)]="itemToSave.profil"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
              >
                <option value="" disabled selected>
                  Sélectionnez un profil
                </option>
                <option value="admin">Administrateur</option>
                <option value="user">Utilisateur</option>
              </select>
            </div>

            <div class="form-group">
              <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                Direction <span class="text-red-500">*</span>
              </label>
              <select
                [(ngModel)]="itemToSave.directionId"
                title="Direction"
                class="w-full h-10 sm:h-11 lg:h-12 border border-gray-300 rounded-lg px-3 sm:px-4 py-2 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 text-sm sm:text-base"
              >
                <option [ngValue]="" disabled>Sélectionnez une direction</option>
                <ng-container *ngFor="let item of itemsDirections">
                  <option [ngValue]="item.id">{{ item.nom }}</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-3 flex-shrink-0">
        <button
          (click)="closeModal()"
          class="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm sm:text-base font-medium"
        >
          Annuler
        </button>
        <button
          (click)="confirmSave(itemToSave)"
          class="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg bg-orange-400 text-white hover:bg-orange-500 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-300 text-sm sm:text-base font-medium"
        >
          {{ itemToSave.id ? "Mettre à jour" : "Enregistrer" }}
        </button>
      </div>
    </div>
  </div>
}